<template>
  <section class="history">
    <div class="container">
      <a-typography-title :level="2"
                          data-aos="fade-right">
        Milestones
      </a-typography-title>
      <div class="box_list"
           data-aos="fade-up">
        <Swiper slidesPerView="auto" :speed="600"
                :navigation="{prevEl:'.button_prev',nextEl:'.button_next',disabledClass:'button_disabled'}">
          <SwiperSlide v-for="(item,index) in tab.list">
            <div v-if="item.type==='year'"
                 class="item i_year">
              <template v-if="index!==0">
                <div class="line" />
                <span>>></span>
              </template>
              {{ item.content.title }}
              <span>>></span>
              <div class="line" />
            </div>
            <div v-else-if="item.type==='event'"
                 class="item i_event" :class="`i_${item.position}`">
              <div class="line" />
              <div class="line" />
              <div class="content">
                <i />
                <a-typography-title :level="5">
                  {{ item.content.title }}
                </a-typography-title>
                <a-typography-paragraph>
                  <p v-for="v in item.content.list">
                    {{ v }}
                  </p>
                </a-typography-paragraph>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div class="item i_year">
              <div class="line" />
              <div class="line" />
            </div>
          </SwiperSlide>
        </Swiper>
        <a-button type="link" class="button_prev" />
        <a-button type="link" class="button_next" />
      </div>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

import { DataInterface } from '@interface/public';

export default {
  name: 'home_history',
  components: {
    Swiper,
    SwiperSlide
  },
  data(): DataInterface {
    return {
      tab: {
        active: 1,
        show: 1,
        list: [
          {
            type: 'year',
            content: {
              title: '2021'
            }
          },
          {
            type: 'event',
            position: 'bottom',
            content: {
              title: 'June 2021',
              list: [
                'Galaxy-Future was founded'
              ]
            }
          },
          {
            type: 'event',
            position: 'top',
            content: {
              title: 'July & August 2021',
              list: [
                'Raised $10 million from two rounds of angel investment led by Future Capital and Matrix Partners China'
              ]
            }
          },
          {
            type: 'event',
            position: 'bottom',
            content: {
              title: 'November 2021',
              list: [
                'Released self-developed engines',
                'Started building our open-source community'
              ]
            }
          },
          {
            type: 'year',
            content: {
              title: '2022'
            }
          },
          {
            type: 'event',
            position: 'top',
            content: {
              title: 'March 2022',
              list: [
                'Released SchedulX V1.1.0',
                'Invention patent granted for DTExpress'
              ]
            }
          },
          {
            type: 'event',
            position: 'bottom',
            content: {
              title: 'April 2022',
              list: [
                'Certified as a member of FinOps Industries Alliance'
              ]
            }
          },
          {
            type: 'event',
            position: 'top',
            content: {
              title: 'June 2022',
              list: [
                'Became a member of China Association of Communication Enterprises'
              ]
            }
          },
          {
            type: 'event',
            position: 'bottom',
            content: {
              title: 'October 2022',
              list: [
                'Released CostPilot V1.1.0'
              ]
            }
          },
          {
            type: 'event',
            position: 'top',
            content: {
              title: 'November 2022',
              list: [
                'Invention patent granted for CudgX'
              ]
            }
          },
          {
            type: 'event',
            position: 'bottom',
            content: {
              title: 'December 2022',
              list: [
                'Selected as one of the "Top 50 Chinese Enterprise Digital Intelligence Innovation Awards 2022"'
              ]
            }
          },
          {
            type: 'year',
            content: {
              title: '2023'
            }
          },
          {
            type: 'event',
            position: 'top',
            content: {
              title: 'April 2023',
              list: [
                'Released the Serverless Application Marketplace GalaxyPilot'
              ]
            }
          },
          {
            type: 'event',
            position: 'bottom',
            content: {
              title: 'September 2023',
              list: [
                'Released the Serverless platform InfraPilot'
              ]
            }
          },
          {
            type: 'year',
            content: {
              title: '2024'
            }
          },
          {
            type: 'event',
            position: 'top',
            content: {
              title: 'March 2024',
              list: [
                'AI application platform with fully upgraded Serverless technology'
              ]
            }
          }
        ]
      }
    };
  },
  beforeCreate(): void {
    SwiperCore.use([ Navigation ]);
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}public/';
@image: '@{src_image}overseas/home/';

.history {
  position: relative;
  padding: 0 @padding;
  background-color: @color_7;
  .bg('@{image}history_bg.png');
  background-position: top center;
  
  &::before {
    content: '';
    display: block;
    .position(top, -30px);
    margin: 0 auto;
    .bg('@{image}history_logo.png', 217px, 127px, true);
    .transform(translate(calc(~'var(--mouse-x,0px) * -0.01'), calc(~'var(--mouse-y,0px) * -0.01')));
  }
  
  .container {
    position: relative;
    z-index: 1;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h2.ant-typography {
  margin: @margin 0 0;
  .font(left, @title_sub, @color_white, @title_sub, true);
  
  &::before {
    @wh: 40px;
    @scale: 0.7;
    content: '';
    display: inline-block;
    width: @wh*@scale;
    height: @wh*@scale;
    margin: 0 5px 0 0;
    .bg('@{image}about_icon.png', @wh*@scale*2, @wh*@scale);
    background-position-x: -@wh+@scale;
    vertical-align: top;
  }
}

.box_list {
  @wh: 64px;
  position: relative;
  margin: @margin_mo 0 0;
  
  .swiper {
    width: calc(~'100% - 150px');
    margin: 0 auto;
    
    .swiper-slide {
      width: auto;
    }
  }
  
  .button_prev,
  .button_next {
    display: block;
    .position(absolute, 0, auto, 0, auto);
    z-index: 1;
    width: @wh;
    height: @wh;
    padding: 0;
    margin: auto 0;
    .bg('@{image}history_icon.png', @wh*2, @wh);
    visibility: visible;
    
    &.button_disabled {
      display: none;
    }
  }
  
  .button_prev {
    left: 0;
    background-position-x: 0;
  }
  
  .button_next {
    right: 0;
    background-position-x: -@wh;
  }
}

.item {
  @w: 80px;
  @h: 260px;
  position: relative;
  height: @h;
  
  &.i_year {
    .font(center, @h, @color_white, @text);
    
    span {
      display: inline-block;
      height: @h;
      margin: 0 5px;
      vertical-align: top;
    }
  }
  
  &.i_event {
    &.i_top {
      .content {
        top: 0;
        
        &::before {
          @style: @color_white 0%, transparent 100%;
          .gradientLinear(0, @style);
        }
        
        i {
          bottom: -5px;
        }
      }
    }
    
    &.i_bottom {
      .content {
        top: @h*0.5;
        
        &::before {
          @style: transparent 0%, @color_white 100%;
          .gradientLinear(0, @style);
        }
        
        i {
          top: -5px;
        }
      }
    }
    
    .content {
      position: absolute;
      left: 0;
      width: 280px;
      height: @h*0.5;
      padding: 0 0 0 @margin_mo;
      vertical-align: top;
      
      &::before {
        content: '';
        display: block;
        .position(left);
        width: 1px;
      }
      
      i {
        display: block;
        position: absolute;
        left: -4px;
        width: 10px;
        height: 10px;
        background: fade(@color_white, 30);
        border-radius: 50%;
        
        &::before {
          content: '';
          .center();
          width: 6px;
          height: 6px;
          margin: auto;
          background: @color_white;
          border-radius: 50%;
        }
      }
      
      h5.ant-typography {
        margin: @margin_mo 0 0;
        .font(left, @text_big, @color_white, @text_big, true);
      }
      
      div.ant-typography {
        margin: @margin_mo 0 0;
        .font(left, @text+5px, @color_white, @text);
        
        p {
          margin: 5px 0 0;
          
          &:first-child {
            margin: 0;
          }
        }
      }
    }
  }
  
  .line {
    display: inline-block;
    position: relative;
    z-index: 0;
    width: @w;
    height: 100%;
    margin: 0 2px 0 0;
    vertical-align: top;
    
    &::before {
      content: '';
      display: block;
      .position(top, calc(~'50% + 1px'));
      border-bottom: 1px dashed @color_white;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .history {
    &::before {
      @scale: 0.5;
      top: -15px;
      .bg('@{image}history_logo.png', 217px*@scale, 127px*@scale, true);
    }
    
    .container {
      padding: @space_mo 0;
    }
  }
  
  h2.ant-typography {
    .font(left, @title_sub_mo, @color_white, @title_sub_mo, true);
    
    &::before {
      @wh: 40px;
      @scale: 0.5;
      width: @wh*@scale;
      height: @wh*@scale;
      .bg('@{image}about_icon.png', @wh*@scale*2, @wh*@scale);
      background-position-x: -@wh*@scale;
    }
  }
  
  .box_list {
    @wh: 30px;
    
    .swiper {
      width: calc(~'100% - 60px');
    }
    
    .button_prev,
    .button_next {
      width: @wh;
      height: @wh;
      .bg('@{image}history_icon.png', @wh*2, @wh);
    }
    
    .button_prev {
      left: -10px;
      background-position-x: 0;
    }
    
    .button_next {
      right: -10px;
      background-position-x: -@wh;
    }
  }
  
  .item {
    &.i_event {
      .content {
        h5.ant-typography {
          .font(left, @text_big_mo, @color_white, @text_big_mo, true);
        }
        
        div.ant-typography {
          .font(left, @text_mo+5px, @color_white, @text_mo);
        }
      }
    }
  }
}
</style>